import { Lead } from '../../types/lead';
import { getTimeZone } from '../utils';

const createLead = async (lead: Lead): Promise<void> => {
  const leadWithTz: Lead = {
    ...lead,
    timezone: getTimeZone(),
  };

  const response = await fetch('/api/v0/leads', {
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(leadWithTz),
  });

  switch (response.status) {
    case 200:
    case 201: return;

    default: throw new Error('Unexpected response');
  }
};

export default createLead;
